// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InsuranceContractPage-module__tabsBox--Q7a2f>div>div {
    display: flex;
    flex-wrap: wrap;
}
.InsuranceContractPage-module__tabsBox--Q7a2f {
    max-width: 1300px;
}`, "",{"version":3,"sources":["webpack://./src/pages/insurance-contract-page/InsuranceContractPage.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB","sourcesContent":[".tabsBox>div>div {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}\r\n.tabsBox {\r\n    max-width: 1300px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabsBox": `InsuranceContractPage-module__tabsBox--Q7a2f`
};
export default ___CSS_LOADER_EXPORT___;
